import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "@/lib/network/csrfToken"

export default class extends Controller {
  static targets = ["row"]
  static values = { url: String }
  declare readonly rowTargets: HTMLElement[]
  declare urlValue: string

  private draggingRow: HTMLElement | null = null

  dragStart(event: DragEvent) {
    this.draggingRow = (event.currentTarget as HTMLElement).closest("tr")
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData(
        "text/plain",
        this.draggingRow?.dataset.id ?? "",
      )
      if (this.draggingRow)
        event.dataTransfer.setDragImage(this.draggingRow, 0, 0)
    }
    this.draggingRow?.classList.add("opacity-50")
  }

  dragEnd() {
    this.draggingRow?.classList.remove("opacity-50")
    this.draggingRow = null
  }

  dragOver(event: DragEvent) {
    event.preventDefault()
    if (!this.draggingRow) return

    const row = event.currentTarget as HTMLElement
    if (row === this.draggingRow) return

    const rect = row.getBoundingClientRect()
    const isAfter = (event.clientY ?? 0) > rect.top + rect.height / 2
    row.parentNode?.insertBefore(
      this.draggingRow,
      isAfter ? row.nextSibling : row,
    )
  }

  async drop(event: DragEvent) {
    event.preventDefault()
    if (!this.draggingRow) return

    const ids = this.rowTargets.map((row) => row.dataset.id)

    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
      body: JSON.stringify({ ids }),
    })
  }
}
